import { render, staticRenderFns } from "./affiliateProductManage.vue?vue&type=template&id=189e5322&scoped=true"
import script from "./affiliateProductManage.vue?vue&type=script&lang=js"
export * from "./affiliateProductManage.vue?vue&type=script&lang=js"
import style0 from "./affiliateProductManage.vue?vue&type=style&index=0&id=189e5322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e5322",
  null
  
)

export default component.exports